import { getCroppingCommands, getFieldCommands } from "../commands";
import { components, FieldViewModel, str } from "../omnia";
import { IFieldsModuleContext } from "../types";

export class MapContextMenuCtrl extends components.PopupMenuCtrl {

    static create() {

        return omnia.defineDirective(MapContextMenuCtrl, "shared/components/popupMenu/popupMenu.html", {
            menu: "="
        });
    }


    private menu: omnia.map.IMapTooltip;

    static $inject = ["$scope"]

    constructor(protected $scope: ng.IScope) {

        super($scope);

        $scope.$watch("vm.menu", () => this.setup());

    }

    private setup() {
        if (this.menu) {

            var target: FieldViewModel = this.menu.data;
            var context: IFieldsModuleContext = this.menu.context;

            this.setupCommands(target, context);

        }
    }

    private setupCommands(target: FieldViewModel, context: IFieldsModuleContext) {

        const fieldCmd = getFieldCommands(context, false)

        if (target.isCropping()) {
            const cropCmd = getCroppingCommands(context, false)
            this.commandsGroups = [
                new components.OmniaCommandGroup(str.CroppingPlural, target, cropCmd),
                new components.OmniaCommandGroup(str.Field, target.fieldVm, fieldCmd, false)
            ];
        }
        else {
            this.commandsGroups = [new components.OmniaCommandGroup(str.Field, target, fieldCmd)];
        }
    }

}
